import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { MSAL_SCOPES } from "./IntuneScopes";
import { getIntuneMsalInstance } from "./intuneMsal";


const AuthResponse = () => {
  const instance = getIntuneMsalInstance();
  const navigate = useNavigate();

  useEffect(() => {
    const handleRedirect = async () => {
      try {
        const response = await instance.handleRedirectPromise();

        if (!response) return;

        const account = response.account;

        if (!account) return;

        instance.setActiveAccount(account);

        await instance.acquireTokenSilent({
          account,
          scopes: MSAL_SCOPES,
        });

        const tenantId = sessionStorage.getItem("selectedTenantId");

        navigate(`/${tenantId}`);
      } catch (error) {
        console.error("MSAL error:", error);
      }
    };

    handleRedirect();
  }, [instance, navigate]);

  return <div>Completing sign-in...</div>;
};

export default AuthResponse;
